<template>
  <div>
    <basic-container>
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in iconList"
          :key="index"
          :xs="12"
          :sm="6"
          :md="3"
          :lg="3"
          :xl="3"
        >
          <router-link
            :to="item.link"
            target="_blank"
            v-if="item.link != undefined"
          >
            <el-card class="icon-panel" shadow="never">
              <vab-icon
                :style="{ color: item.color }"
                :icon="['fas', item.icon]"
              ></vab-icon>
              <p>{{ item.title }}</p>
            </el-card>
          </router-link>
        </el-col>
      </el-row>

      <div class="banner-text">
        <br />
        <span>
          <div>{{ this.hellTest }}</div>
          <!-- <div
            v-if="
              trAbilityQc !== null &&
              trAbilityQcLog !== null &&
              trAbilityQcLog?.type === 1 &&
              trAbilityQc?.status === 'n'
            "
            style="color: red"
          >
            <div>
              您的质控账号接单状态已{{
                trAbilityQc?.status === 'n' ? '禁用' : '启用'
              }},{{
                trAbilityQcLog?.remark.substring(
                  0,
                  trAbilityQcLog?.remark.indexOf('】') + 1,
                )
              }}
            </div>
            <div>
              禁用理由:
              {{
                trAbilityQcLog?.remark.substring(
                  trAbilityQcLog?.remark.indexOf('】') + 1,
                )
              }}
            </div>
          </div>
          <div
            v-if="
              trAbilityQc !== null &&
              trAbilityQcLog !== null &&
              trAbilityQcLog?.type === 2
            "
            style="color: red"
          >
            <div>
              您的质控分数已调整，调整后的分数为{{ trAbilityQc?.score }}分
            </div>
            <div>
              信用分操作理由:
              {{
                trAbilityQcLog?.remark.substring(
                  trAbilityQcLog?.remark.indexOf('】') + 1,
                )
              }}
            </div>
          </div> -->
        </span>
        <div v-if="isShowEditPassword" class="m-t-10">
          您的密码已过期，请点击前往
          <a class="c-409EFF c-p" @click="toEditPassword">修改密码</a>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getTrAbilityQcAndLogByStaffId, forceChangePwd } from '@/api/qc/manage';
import iconList from '@/const/iconList'; //临时
export default {
  name: 'wel',
  data() {
    return {
      trAbilityQc: null,
      trAbilityQcLog: null,
      activeNames: ['1', '2', '3', '4'],
      DATA: [],
      text: '',
      actor: '',
      count: 0,
      isText: false,
      // 图标
      iconList: iconList,
      hellTest: '',
      isShowEditPassword: false,
    };
  },
  computed: {
    ...mapGetters(['website', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  beforeMount() {
    forceChangePwd().then((res) => {
      if (res.data.data === 2) {
        this.isShowEditPassword = true;
      } else {
        this.isShowEditPassword = false;
      }
    });

    // getTrAbilityQcAndLogByStaffId(
    //   Object.assign({
    //     staffId: this.userInfo.staffId,
    //   }),
    // ).then((res) => {
    //   console.log(res.data.data);
    //   if (res.data.data) {
    //     this.trAbilityQc = res?.data?.data?.dotQcInfo;
    //     this.trAbilityQcLog = res?.data?.data?.trAbilityQcLog;
    //   } else {
    //   }
    // });
  },
  mounted: function () {
    let hh = new Date().getHours();
    if (hh >= 0 && hh <= 4) {
      this.hellTest = this.$stringFormat('夜深人静了，{0}，早点休息吧。', [
        this.userInfo.realname,
      ]);
    } else if (hh >= 5 && hh <= 6) {
      this.hellTest = this.$stringFormat('天还刚刚亮，{0}，辛苦了。', [
        this.userInfo.realname,
      ]);
    } else if (hh >= 7 && hh <= 8) {
      this.hellTest = this.$stringFormat(
        '早上好，{0}，记得每天不要忘记吃美味的早餐哦。',
        [this.userInfo.realname],
      );
    } else if (hh >= 9 && hh <= 11) {
      this.hellTest = this.$stringFormat('上午好，{0}。', [
        this.userInfo.realname,
      ]);
    } else if (hh >= 12 && hh <= 13) {
      this.hellTest = this.$stringFormat(
        '中午好，{0}，吃个丰盛午餐 , 好好休息一下 , 才更有精神展开下午的工作哦。',
        [this.userInfo.realname],
      );
    } else if (hh === 14) {
      this.hellTest = this.$stringFormat(
        '下午好，{0}，繁忙而又充实的下午已经开始了。',
        [this.userInfo.realname],
      );
    } else if (hh === 15) {
      this.hellTest = this.$stringFormat(
        '下午好，{0}，来一份精致的下午茶，提提神吧！',
        [this.userInfo.realname],
      );
    } else if (hh >= 16 && hh <= 19) {
      this.hellTest = this.$stringFormat('下午好，{0}。', [
        this.userInfo.realname,
      ]);
    } else if (hh >= 20 && hh <= 22) {
      this.hellTest = this.$stringFormat('晚上好，{0}。', [
        this.userInfo.realname,
      ]);
    } else if (hh >= 23) {
      this.hellTest = this.$stringFormat(
        '夜深了，{0}，应该休息了，明天才有好的状态，迎接新的工作。',
        [this.userInfo.realname],
      );
    }
  },

  methods: {
    toEditPassword() {
      window.location.href = '/m_op/editPassword/1783740821374054402';
      // this.$router.push({
      //   path: '/info/index',
      //   query: {
      //     tabId: '2',
      //   },
      // });
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.c-p {
  cursor: pointer;
}
.wel-contailer {
  position: relative;
}

.banner-text {
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  text-align: center;
  color: #333;
}

.banner-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  display: none;
}

.actor {
  height: 250px;
  overflow: hidden;
  font-size: 18px;
  color: #333;
}

.actor:after {
  content: '';
  width: 3px;
  height: 25px;
  vertical-align: -5px;
  margin-left: 5px;
  background-color: #333;
  display: inline-block;
  animation: blink 0.4s infinite alternate;
}

.typeing:after {
  animation: none;
}

@keyframes blink {
  to {
    opacity: 0;
  }
}
</style>
